import { ScriptService } from './shared/services/script.service';
 import { NavigationService } from './shared/services/navigation.service';
import { Component, OnInit, Renderer2 } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
} from "@angular/router";
import { RoutePartsService } from "./shared/services/route-parts.service";
import { filter } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { MatSnackBarConfig } from "@angular/material/snack-bar";
import { ResizeService } from "./shared/services/resize.service";
import { environment } from '../environments/environment';
import { AppService } from "./app.service";
import axios from "axios";
import { LocalStoreService } from './shared/services/local-store.service';
import { staticSuppliers } from './staticData';
import { KycStatusService } from './shared/services/kyc-status.service';
import { PrivateFileService } from './shared/services/private-file.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  appTitle = "VS-MPS";
  pageTitle = "";
  tokens: any;
  snackBarConfig: any;
  windowSize!: { width: number; height: number; };
  isAdminUser: boolean = false;
  showChatbot = false;
  private readonly chatbotExcludedRoutes = [
    '/auth',
    '/operations/token-login',
    '/operations/po-token',
    '/token-login',
    // Public KYC magic-link page is supplier-facing without portal
    // login. The chatbot is for authenticated buyers/suppliers only,
    // so hide it on this surface regardless of any tokenId cookie
    // left over from another tab.
    '/kycToken'
  ];

  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private cookieService: CookieService,
    private resizeService: ResizeService,
     private navigationService: NavigationService,
    private scriptService: ScriptService,
    private renderer: Renderer2,
    private appService: AppService,
    private ls: LocalStoreService,
    private kycStatus: KycStatusService,
    private privateFiles: PrivateFileService
  ) {
    // 2026-10-25 (S3 step 2): private S3 files open through short-lived signed links (see PrivateFileService).
    this.privateFiles.installGlobalHandlers();
    this.snackBarConfig = new MatSnackBarConfig()
    this.snackBarConfig.verticalPosition = 'top';
    this.snackBarConfig.horizontalPosition = 'center';
    this.snackBarConfig.panelClass = "custom-snack";

    setInterval(()=>{
      //Enter the api call here
      axios.get(environment.apiURL)
      
    },900000)
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.evaluateChatbotVisibility(event.urlAfterRedirects || event.url);
      });
  }

  ngOnInit() {
    this.evaluateChatbotVisibility(this.router.url);
    /*const zoomMarkerScriptElement = this.scriptService.loadJsScript(this.renderer,
      `${environment.assetsLink}js/zoom-marker.js`
    );
    zoomMarkerScriptElement.onload = () => { };*/

    this.navigationService.assignCountries()

    // Author: Akarsh Singh | 2026-09-08
    // Start the KYC status fetch as soon as the app boots.
    //
    // KycAccessGuard awaits this status before Angular will activate any gated
    // route, so it sits on the critical path of every page. It was previously
    // kicked off by the layout component, which does not mount until its chunk
    // has loaded - measured at ~2.6s on dev, while the other startup calls were
    // already in flight by ~0.9s. Starting it here overlaps it with them.
    //
    // This does NOT weaken the gate: the guard still awaits the result and
    // still enforces it. KycStatusService de-duplicates in-flight requests, so
    // the guard and the layout both join this one call instead of adding more.
    // Skipped when no user is signed in, so the login screen stays untouched.
    if (this.cookieService.get('userId')) {
      this.kycStatus.refresh().catch(() => {
        // Non-fatal: the guard re-fetches if this did not succeed.
      });
    }

    const hammerScriptElement = this.scriptService.loadJsScript(this.renderer,
      `${environment.assetsLink}js/hammer.min.js`
    );
    hammerScriptElement.onload = () => {  };

    const jqueryMouseweelScriptElement = this.scriptService.loadJsScript(this.renderer,
      `${environment.assetsLink}js/easy-loading.js`
    );
    jqueryMouseweelScriptElement.onload = () => { };

    const dragscrollScriptElement = this.scriptService.loadJsScript(this.renderer,
      `${environment.assetsLink}js/dragscroll.js`
    );
    dragscrollScriptElement.onload = () => {  };

     document.documentElement.style.setProperty("--signup2-section-left-bg-img", `url(${environment.assetsLink + 'images/bg.png'})`);
     document.documentElement.style.setProperty("--cancel-image-scaffolding", `url(${environment.assetsLink + 'images/cancel.png'})`);
     document.documentElement.style.setProperty("--home-bg-black", `url(${environment.assetsLink + 'images/home-bg-black.png'})`);
     document.documentElement.style.setProperty("--signup3-trianglify", `url(${environment.assetsLink + 'images/backgrounds/trianglify-1.png'})`);
     document.documentElement.style.setProperty("--signup4-waterfall", `url(${environment.assetsLink + 'images/backgrounds/waterfall.jpg'})`);
    if (this.cookieService.get("tokenId") != null
      && this.cookieService.get("tokenId") != ""
      && typeof this.cookieService.get("tokenId") != "undefined") {

      // User not admin then check user type [Ship Manager | Ship Owner]
      let isAdmin = this.cookieService.get("isAdmin") ? JSON.parse(this.cookieService.get("isAdmin")) : false;
      let userRole = this.cookieService.get("userRole") ? this.cookieService.get("userRole") : null;
      this.resizeService.getWindowSize();

       this.navigationService.assignMenuItems();

      let windowRoute = window.location.href
        .split(window.location.origin)
        .pop();
      if (windowRoute === "/") {
        if (isAdmin || (userRole ? userRole.trim().toLocaleLowerCase() == 'admin user' : null)) {
          //this.router.navigateByUrl(`/dashboard/admin`);
          this.router.navigateByUrl(`/dashboard/supplier`);
        } else {
         // this.router.navigateByUrl(`/dashboard/owner`);
         this.router.navigateByUrl(`/dashboard/supplier`);
        }
      }
    }
    // Evaluate chatbot visibility after auth check
    this.showChatbot = this.isUserLoggedIn() && this.showChatbot;

     this.changePageTitle();

     this.ls.setItem('suppliersList',staticSuppliers);
  }

  changePageTitle() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((routeChange) => {
        var routeParts = this.routePartsService.generateRouteParts(
          this.activeRoute.snapshot
        );
        if (!routeParts.length) return this.title.setTitle(this.appTitle);
        // Extract title from parts;
        this.pageTitle = routeParts
          .reverse()
          .map((part) => part.title)
          .reduce((partA, partI) => {
            return `${partA} > ${partI}`;
          });
        this.pageTitle += ` | ${this.appTitle}`;
        this.title.setTitle(this.pageTitle);
      });
  }

  private evaluateChatbotVisibility(url: string): void {
    if (!url) {
      this.showChatbot = true;
      return;
    }
    const cleanedUrl = url.split('?')[0];
    const routeAllowed = !this.chatbotExcludedRoutes.some((route) =>
      cleanedUrl.startsWith(route)
    );
    this.showChatbot = routeAllowed && this.isUserLoggedIn();
  }

  private isUserLoggedIn(): boolean {
    const token = this.cookieService.get("tokenId");
    return !!token && token !== "undefined";
  }
}
